<template>
	<div class="main">
		<div class="product">
      <div class="pro"><router-link :to="{path:'/'}" class="link"><span >{{$t('nav.home')}} > </span></router-link>{{$t('nav.about')}}</div>
			<div class="h_title">
				<el-image src="./static/image/tleft.png" fit="contain"></el-image>{{$t('nav.about')}}
				<el-image src="./static/image/tright.png" fit="contain"></el-image>
		  </div>
			<div class='about' v-if="$i18n.locale == 'zh'" v-html="join.join">
			</div>
			<div class='about' v-else-if="$i18n.locale == 'en'" v-html="join.y_join">
      </div>
			<div class='about' v-else v-html="join.e_join">
      </div>
			<!-- 简历投递方式 -->
			<div class='jli'>{{$t('td')}}</div>
			<div class="cen_ji">
				<div class="timg"><el-image src="./static/image/icon_spot@2x.png" fit="contain"></el-image>HR{{$t('email')}}：{{join.hr_email}}</div>
				<div class="timg"><el-image src="./static/image/icon_spot@2x.png" fit="contain"></el-image>HR{{$t('ell')}}：{{join.hr_phone}}</div>
			</div>
			<!-- 职位列表 -->
			<div class='jli'>{{$t('zwlb')}}</div>
			<div class="pro_list">
				<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column prop="scope" :label="$t('join.zw')" width="300">
							<template slot-scope="scope">
								<span v-if="$i18n.locale == 'zh'">{{scope.row.name}}</span>
								<span v-else-if="$i18n.locale == 'en'">{{scope.row.y_name}}</span>
								<span v-else>{{scope.row.e_name}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="scope" :label="$t('join.bm')" width="300">
								<template slot-scope="scope">
								<span v-if="$i18n.locale == 'zh'">{{scope.row.department}}</span>
								<span v-else-if="$i18n.locale == 'en'">{{scope.row.y_department}}</span>
								<span v-else>{{scope.row.e_department}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="scope" :label="$t('join.dd')" width="300">
							<template slot-scope="scope">
								<span v-if="$i18n.locale == 'zh'">{{scope.row.province}}</span>
								<span v-else-if="$i18n.locale == 'en'">{{scope.row.y_province}}</span>
								<span v-else>{{scope.row.e_province}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="scope" :label="$t('join.yq')" width="300">
							<template slot-scope="scope">
								<span class="mores" @click="$router.push({ path: '/about/aboutdetail?id='+ scope.row.id })">{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image></span>
							</template>
						</el-table-column>
				</el-table>
			</div>
			<div class="page">
					<el-pagination
							@current-change="handleCurrentChange"
							:current-page="currentPage4"
							:page-size="10"
							layout="total, prev, pager, next, jumper"
							:total="count"
					>
					</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				currentPage4:1,
				tableData:[],
				page:1,
				limit:10,
				join:{},
				count:0,
			}
		},
		mounted() {
			this.getPor()
		},
		methods: {
			// 当前页数
			handleCurrentChange(val) {
					console.log(`当前页: ${val}`);
					this.page = val;
					this.getPor();
			},
			// 
			getPor() {
				var that = this;
				this.$axios
					.post("/api/index/join", {
						page:this.page,
						limit:this.limit
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.join = ret.data.data
							that.join.join = that.convert(ret.data.data.join);
							console.log('1111111',that.join.join)
							that.join.y_join = that.convert(ret.data.data.y_join);
							if(ret.data.data.e_join){
								that.join.e_join = that.convert(ret.data.data.e_join);

							}
							

							that.tableData=ret.data.data.job
              that.count=ret.data.data.count
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			convert (htmlText) {
				// let htmlText = '<img style="border: 0px; width: 537px; display: block;">'
				let str = htmlText.replace(/<img[^>]*>/gi, function (match, capture) {
					return match.replace(/(<img[^>]*)(\/?>)/gi, "$1width='100%' $2") // 添加width="100%"
					return match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, 'style="width:96%;height:auto;"') // 替换style
				})
				return str
			},
    }
	}
</script>

<style lang="scss" scoped>
	
	.main {
		background-color: #FFFFFF;
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;

		.introduce {
			width: 1200px;
			height: 433px;
			margin: 60px 0;
			display: flex;
			// align-items: center;
			justify-content: space-between;

			.ad {
				width: 800px;
				height: 433px;
			}

			.info {
				width: 800px;
				height: 433px;
				padding-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 30px;
					color: #004098;
					font-weight: bold;
				}

				span {
					display: block;
					width: 40px;
					height: 4px;
					background: #004098;
					margin-top: 20px;
				}

				.cro {
					font-size: 18px;
					color: #333;
					margin: 20px 0;
				}

				.text {
					height: 300px;

					p {
						font-size: 16px;
						color: #999;
						text-indent: 2em;
					}

				}
				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
			}
			.info2 {
				background-color: #F7F8FA;
				padding: 50px 40px;
			}
		}
		.h_title {
			font-size: 30px;
			color: #004098;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1200px;
			padding: 40px 0;
			font-weight: bold;

			.el-image {
				// width: 515px;
				width: 490px;
				height: 13px;
			}
		}

		.range {
			width: 1200px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.li {
				font-size: 16px;
				color: #333;
				display: flex;
				align-items: center;
				flex-direction: column;

				.el-image {
					width: 70px;
					height: 70px;
					padding: 15px;
					margin-bottom: 15px;
					background-color: #004098;
				}
			}
		}

		.el-carousel {
			width: 1200px;
		}

		.product {
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 60px;

			.list {
				width: 1200px;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
                flex-wrap:wrap;
				.shop {
					width: 390px;
					height: 400px;
					background: #FFFFFF;
					padding: 20px;
					display: flex;
					flex-direction: column;
                    margin-bottom: 20px;
					.el-image {
						width: 350px;
						height: 260px;
					}
					.title {
						font-size: 20px;
						color: #333;
						margin: 15px 0;
					}

					.text {
						font-size: 16px;
						color: #666;
					}

					.link {
						font-size: 16px;
						color: #004098;
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 10px;

						.el-image {
							width: 16px;
							height: 16px;
							margin-left: 5px;
						}
					}
				}
			}
		}

        .pro{
            width: 1200px;
            line-height:30px;
            margin:40px 0 0;
            overflow: hidden;
            text-align: left;
						font-size: 14px;
						a{
							text-decoration: none;
							color: #303133;
							font-weight: 700;
						}
        }	
        .about{
            width: 1200px;
            margin: 10px auto;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 30px;
            color: #333333;
        }
        .jli{
            width: 1200px;
            margin: 50px auto;
            overflow: hidden;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }
        .imgs .el-image{
            width: 20px;
            height: 20px;
            margin-top: 15px;
            margin-right: 20px;
            vertical-align:-5px;
        }
        .list_one{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 20px;
            color: #004098;
        }
        .pro_list{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
        }
        .page{
            width: 1200px;
            text-align: right;
            overflow: hidden;
            margin:40px 0;
        }
		.cen_ji{
			width: 1200px;
			text-align: center;
		}
		.timg{
			width: 1200px;
			text-align: left;
			font-size: 18px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			line-height: 20px;
			color: #004098;
			margin: 5px 0;
		}
		.timg .el-image{
			width: 20px;
			height: 20px;
			margin-top: 5px;
			vertical-align: -3px;
			margin-right: 10px;
		}
		.mores{
			line-height: 40px;
		}
		.mores .el-image{
			width: 20px;
			height: 20px;
			margin-top: 5px;
			vertical-align: -3px;
			margin-left: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue